import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation, withInMemoryScrolling, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { environment } from '../environments/environment';
import { Palettes } from '../themes/palette';
const AuraIndigo = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e6f0fb',
      100: '#cce1f7',
      200: '#99c3ee',
      300: '#66a5e5',
      400: '#3387dd',
      500: '#004585', // Custom primary color
      600: '#003c78',
      700: '#003266',
      800: '#002953',
      900: '#001f42',
      950: '#001231'
    },
    secondary: {
      50: '#fff4e6',
      100: '#ffeacc',
      200: '#ffd599',
      300: '#ffc066',
      400: '#ffab33',
      500: '#EE7F01', // Custom secondary color
      600: '#d77101',
      700: '#b86001',
      800: '#984f01',
      900: '#783e01',
      950: '#502900'
    },
    text: {
      default: '#373737', // Custom text color
      error: '#E42F17',   // Custom text error color
    }
  }
});

import { getSociedadActivaByDOM } from './service/config.service';

const currentSociedad = typeof window !== 'undefined' ? getSociedadActivaByDOM(window.location) : environment.sociedad;
const selectedPalette: any = Palettes[currentSociedad] || Palettes[environment.sociedad];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes,
      //withHashLocation(),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      })),
    provideHttpClient(),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: selectedPalette,
        options: {
          prefix: 'p',
          darkModeSelector: 'system',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities'
          }
        }
      }
    }),
    { provide: LOCALE_ID, useValue: 'es-BO' }]
};
